<template>
  <div class="va-chat ">
    <div
      class="va-chat__body "
      :style="{'height': height}"
      v-sticky-scroll="{
        animate: true,
        duration: 500
      }"
    >
      <div
        class="va-chat__message  "
        v-for="(message, index) in allAvisos"
        :key="index"
        
      >
      
      <va-card :title="message.nome_funcionario">
          {{ message.mensagem }}
      </va-card>



      </div>
    </div>
    <div class="va-chat__controls">
      <va-input
        v-model="avisos.mensagem"
        @keypress.enter="sendMessage"
        placeholder="Mensagem"
        class="va-chat__input"
      />
      <va-button color="info" @click="sendMessage()">
        Enviar
      </va-button>
    </div>
  </div>
</template>

<script>
import StickyScroll from 'vuestic-ui/src/components/vuestic-directives/StickyScroll'

export default {  
  name: 'chat',
  directives: { StickyScroll },
  data () {
    return {   

      avisos: {
            mensagem:'',
            funcionario_id:this.$store.state.professor.setProfessor.id,
            oferta_data_disciplina_id: this.$store.state.datamateria.setmateria.id
          },

      disciplina:  {
        id: this.$store.state.datamateria.setmateria.id,
        nome: this.$store.state.datamateria.setmateria.nome_disciplina,
      } 

    }
  },
  created(){
      this.all();
      
    },
  props: {
    
    height: {
      default: '20rem',
      type: String,
    },
  },
  computed: {
     allAvisos() {

      return  this.$store.state.mensagens.allAvisosDisciplina 
      
    },
  },
  methods:{

   async sendMessage(){
     console.log(this.avisos)
      await this.$store.dispatch('addAvisos',this.avisos)
        this.avisos= {
            mensagem:'',
            funcionario_id:this.$store.state.professor.setProfessor.id,
            oferta_data_disciplina_id: this.$store.state.datamateria.setmateria.id
          
        } 
      this.all()
    },

   async all() {

       await this.$store.dispatch('allAvisosDisciplina',this.disciplina.id )

    },
  },
}
</script>

<style lang='scss' scoped>



.tamanho_avisos {
  width: 100%; 
}
.chat {
  &__content {
    @include va-flex-center();
  }
}

$chat-message-br: .875rem;

.va-chat {
  // width: 100%; 

  &__body {
    min-height: 18.75rem;
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
    overflow-y: auto;
  }

  &__message {
    position: relative;
    padding: .657rem 1.375rem;
    margin-bottom: .625rem; 
    max-width: 100%;
    overflow-wrap: break-word;
    border-radius: 0.5rem;
    border-top-left-radius: 0;

    align-self: flex-start;
    background-color: $light-gray2;

    &-text {
      display: block;
      transform: translateY(-2px);
    }

    &:last-child {
      margin-bottom: 0;
    }

    &--yours {
      color: black;
      align-self: flex-end;
      border-top-right-radius: 0;
      border-top-left-radius: 0.5rem;
    }
  }

  &__controls {
    display: flex;
    align-items: center;
  }

  &__input {
    margin-bottom: 0;
  }
}
</style>
